var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3919 14.1C12.1487 15.1798 10.5254 15.8334 8.74935 15.8334C4.83733 15.8334 1.66602 12.6621 1.66602 8.75008C1.66602 4.83806 4.83733 1.66675 8.74935 1.66675C12.6614 1.66675 15.8327 4.83806 15.8327 8.75008C15.8327 10.5262 15.179 12.1496 14.0991 13.3929L18.186 17.4798C18.3813 17.6751 18.3813 17.9917 18.186 18.187C17.9908 18.3822 17.6742 18.3822 17.4789 18.187L13.3919 14.1ZM14.8327 8.75008C14.8327 12.1098 12.1091 14.8334 8.74935 14.8334C5.38962 14.8334 2.66602 12.1098 2.66602 8.75008C2.66602 5.39035 5.38962 2.66675 8.74935 2.66675C12.1091 2.66675 14.8327 5.39035 14.8327 8.75008Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.185c80aa8156ba7c084a571ee6eecb30.svg";
export { ForwardRef as ReactComponent };